import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, unref as _unref, createVNode as _createVNode, createBlock as _createBlock } from "vue"
import _imports_0 from '../assets/loading.gif'
import _imports_1 from '../assets/information.svg'
import _imports_2 from '../assets/detail.svg'
import _imports_3 from '../assets/favorite-icon.svg'
import _imports_4 from '../assets/person.svg'
import _imports_5 from '../assets/capacity.svg'


const _hoisted_1 = {
  key: 0,
  class: "loading"
}
const _hoisted_2 = {
  key: 1,
  class: "project-detail"
}
const _hoisted_3 = { class: "header" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "warnig-banner-message" }
const _hoisted_6 = { class: "project-detail-content1" }
const _hoisted_7 = { class: "project-detail-content1-img-area" }
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "project-detail-content1-title pt-21" }
const _hoisted_10 = {
  key: 0,
  class: "project-detail-content1-title pt-15 pb-12"
}
const _hoisted_11 = {
  key: 1,
  class: "project-detail-content1-title pt-15 pb-12"
}
const _hoisted_12 = { class: "project-detail-content1-condition pb-5" }
const _hoisted_13 = ["src"]
const _hoisted_14 = { class: "project-detail-content1-condition" }
const _hoisted_15 = { class: "project-detail-content1-condition2 pt-15" }
const _hoisted_16 = { class: "project-detail-sub-header" }
const _hoisted_17 = {
  class: "p__style__4 pt-25",
  style: {"color":"#a3a3a3"}
}
const _hoisted_18 = { class: "p__style__4 pt-3" }
const _hoisted_19 = { class: "project-detail-content3" }
const _hoisted_20 = { class: "p__style__4 pb-50 pt-20" }
const _hoisted_21 = { class: "project-detail-content3-ng" }
const _hoisted_22 = { class: "ng-list" }
const _hoisted_23 = { class: "p__style__4 pt-22 pb-20" }
const _hoisted_24 = {
  key: 0,
  type: "disc",
  style: {"margin-bottom":"14px"}
}
const _hoisted_25 = { class: "project-detail-content4 mt-50" }
const _hoisted_26 = { class: "p__style__4" }
const _hoisted_27 = { class: "p__style__4" }
const _hoisted_28 = { class: "p__style__4" }
const _hoisted_29 = { class: "p__style__4" }
const _hoisted_30 = { class: "p__style__4" }
const _hoisted_31 = { class: "p__style__4" }
const _hoisted_32 = {
  key: 0,
  class: "p__style__4"
}
const _hoisted_33 = {
  key: 1,
  class: "p__style__4"
}
const _hoisted_34 = { class: "contact" }
const _hoisted_35 = { class: "footer" }

import { onMounted, ref } from "vue";
import ComfirmDialog from "./ComfirmDialog.vue";
import CommonButton from "./CommonButton.vue";
import ContactDialog from "./ContactDialog.vue";
import { CommonStore } from "../store/CommonStore";
import { UserInfoStore } from "../store/UserInfoStore";

import { useRoute } from "vue-router";
import router from "../router";

import {
  APPLICATION_STATE,
  BUTTON_NAME,
  MEDIA_ICON,
  MEDIA_NAME,
} from "../consts/common";
import { ProjectStore } from "../store/ProjectStore";
import { projectDetail } from "../types/apiResponse";
import dayjs from "dayjs";

export default /*@__PURE__*/_defineComponent({
  __name: 'ProjectDetail',
  setup(__props) {

const commonStore = CommonStore();

const dialog = ref<InstanceType<typeof ComfirmDialog>>();
const contactDialog = ref<InstanceType<typeof ContactDialog>>();
const projectStore = ProjectStore();
const loading = ref(false);
const message = ref("");
const userInfoStore = UserInfoStore();

const showDialog = ref(false);
const showContactDialog = ref(false);
const button = ref("");
const isEntryEnd = ref(false);
const addUpdateFavorite = ref(false);
const detail = ref<projectDetail>({
  aplication_state: 0,
  banner: {
    message: "案件に応募するためにはプロフィール登録が必要です",
    target: "sign-up",
  },
  client: {
    id: 0,
    name: "",
  },
  confirm_deadline: "",
  description: "",
  draft: null,
  document_url: "",
  entry_ended_at: "",
  entry_started_at: "",
  has_shipment: false,
  hashtag: "",
  id: -1,
  image: "",
  is_favorited: false,
  is_needed_review: false,
  is_offer: false,
  link_url: "",
  media_type: 0,
  min_follower_count: 0,
  note: "",
  orientation_url: "",
  outsourcing_amount: 0,
  payment_due_date: "投稿月の翌月末",
  post_ended_at: "",
  post_started_at: "",
  products: [
    {
      brand_name: "",
      brand_name_kana: "",
      description: "",
      id: 0,
      manufacturer_name: "",
      name: "",
      url: "",
    },
  ],
  prohibitions: [],
  recruitment_numbers: 0,
  state: 0,
  title: "",
});

const setMediaIcon = (media_type: number) => {
  return MEDIA_ICON[media_type];
};
const setMediaName = (media_type: number) => {
  return MEDIA_NAME[media_type];
};
// 日付をYYYY年MM月DD日にフォーマットして返す
const setDiaplayDate = (date: string, isEndDate: boolean) => {
  // 募集終了期間は管理画面で00:00に設定されているため-1日表示する
  if (isEndDate) {
    const enddate = new Date(date)
    enddate.setDate(enddate.getDate() - 1)
    return dayjs(new Date(enddate)).format("YYYY年MM月DD日");
  } 
  return dayjs(new Date(date)).format("YYYY年MM月DD日");
};
// 応募する 応募済 キャンセル済 応募不可
function setButton() {
  if (detail.value.id == -1) return { status: 0, button: "" };
  if (isEntryEnd.value) {
    return {
      status: 2,
      button: "募集終了",
    };
  }
  const result = BUTTON_NAME.get(detail.value.aplication_state);
  if (!result) {
    return {
      status: 2,
      button: "応募済",
    };
  }

  return BUTTON_NAME.get(detail.value.aplication_state);
}

// 確認ダイアログを表示する
const confirm = () => {
  if (isEntryEnd.value) return;
  // ユーザー応募ステータスが応募前もしくはキャンセル済以外はボタンが押せないようにする
  if (
    detail.value.aplication_state == APPLICATION_STATE.BEFORE_APPLY ||
    detail.value.aplication_state == APPLICATION_STATE.CANCELED
  ) {
    if (
      detail.value.aplication_state == APPLICATION_STATE.BEFORE_APPLY &&
      dialog.value
    ) {
      showDialog.value = true;
      message.value = "この案件への応募しますか?";
      button.value = "応募する";
      dialog.value.openDialog();
    } else if (detail.value.aplication_state == APPLICATION_STATE.CANCELED) {
      showDialog.value = true;
      message.value = "この案件への再応募しますか?";
      button.value = "再応募する";
      dialog.value?.openDialog();
    }
  }
};

function copyHashTag() {
  navigator.clipboard.writeText(detail.value.hashtag);
  commonStore.setToast({
    showToast: true,
    message: "ハッシュタグをコピーしました",
    state: 0,
    timeout: 2000,
  });
}

function openContactDialog() {
  showContactDialog.value = true;
  contactDialog.value?.openContactDialog();
}

const splitHashTag = (hashTag: string) => {
  const hashTags = hashTag.replaceAll("＃", "#").trim().split("#");
  // 空白は削除
  return hashTags.filter(Boolean);
};
// 案件応募
const applyProject = async () => {
  loading.value = true;
  const res = await projectStore.applyProject();
  if (res) {
    detail.value.aplication_state = APPLICATION_STATE.APPLIED;
  }
  loading.value = false;
};

// お気に入り追加解除
async function updateFavorite() {
  if (detail.value.is_favorited) {
    const result = await projectStore.deleteFavoriteProject(detail.value.id);
    if (result) {
      detail.value.is_favorited = false;
      projectStore.updateActiveProject(
        detail.value,
        commonStore._mediaId,
        false
      );
      addUpdateFavorite.value = false;
    }
  } else {
    const result = await projectStore.addFavoriteProject(detail.value);
    if (result) {
      detail.value.is_favorited = true;
      projectStore.updateActiveProject(
        detail.value,
        commonStore._mediaId,
        true
      );
      addUpdateFavorite.value = true;
    }
  }
}

function push() {
  userInfoStore.setIsRegistFromProjectDetail({
    show: true,
    title: detail.value.title,
    mediaType: detail.value.media_type,
  });
  // ユーザー未登録であれば、ユーザー登録→銀行口座登録→SNS登録→住所登録
  // 銀行口座未登録であれば、銀行口座登録→SNS登録？（未登録であれば）→住所登録（未登録であれば）
  // SNS未登録であればSNS登録→住所登録（未登録であれば）
  // SNS未登録であればSNS登録画面に遷移、ユーザー登録情報が不足していればユーザー情報更新画面に遷移
  // 住所未登録であれば住所登録
  router.replace("/" + detail.value.banner.target);
}

const state = ref(0);
const route = useRoute();

/** リンク */
const linkTo = (link: string) => {
  // window.location.href = link
  window.open(link);
};
onMounted(async () => {
  // 応募前案件か応募中案件か
  state.value = +(route.query.state || 0);
  loading.value = true;
  // 案件詳細API
  const res = await projectStore.getProjectDetail();
  if (!res) {
    setTimeout(() => {
      commonStore.setToast({
        showToast: true,
        message: "読み込みに失敗しました",
        state: 1,
        timeout: 2000,
      });

      setTimeout(() => {
        router.back();
      }, 3000);
    }, 1000);
  } else {
    detail.value = res;
    document.title = res.title;
    // 管理画面に入力されている募集日時が00:00で入力されているため表示する日付を-1する
    if ((Math.floor((new Date(detail.value.entry_ended_at).getTime() - (new Date(new Date().toDateString())).getTime()) / (24 * 60 * 60 * 1000))) -1 < 0) {
      isEntryEnd.value = true;
    }
    loading.value = false;
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _cache[9] || (_cache[9] = [
          _createElementVNode("img", { src: _imports_0 }, null, -1 /* HOISTED */)
        ])))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", {
      class: _normalizeClass([loading.value ? 'l-modal__bg' : ''])
    }, null, 2 /* CLASS */),
    (detail.value.id > -1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("header", _hoisted_3, [
            (detail.value.banner && setButton().button != '応募済' && !isEntryEnd.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createElementVNode("div", {
                    class: "warnig-banner",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (push()))
                  }, [
                    _cache[10] || (_cache[10] = _createElementVNode("img", {
                      class: "detail_icon",
                      src: _imports_1,
                      align: "left"
                    }, null, -1 /* HOISTED */)),
                    _createElementVNode("p", _hoisted_5, _toDisplayString(detail.value.banner.message), 1 /* TEXT */),
                    _cache[11] || (_cache[11] = _createElementVNode("img", {
                      class: "detail_icon",
                      src: _imports_2,
                      align: "right"
                    }, null, -1 /* HOISTED */))
                  ])
                ]))
              : _createCommentVNode("v-if", true)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("img", {
                class: "project-detail-content1-img",
                src: detail.value.image,
                alt: "案件画像",
                loading: "lazy",
                style: _normalizeStyle(isEntryEnd.value ? 'filter: brightness(0.7);' : '')
              }, null, 12 /* STYLE, PROPS */, _hoisted_8),
              _createCommentVNode("お気に入りicon"),
              _createElementVNode("div", {
                class: "favorite",
                onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (updateFavorite()), ["stop"]))
              }, [
                _createElementVNode("img", {
                  src: _imports_3,
                  class: _normalizeClass([
              addUpdateFavorite.value && detail.value.is_favorited
                ? 'update-favorite-icon'
                : detail.value.is_favorited
                ? 'favorite-icon'
                : '',
            ])
                }, null, 2 /* CLASS */)
              ]),
              _createCommentVNode(" <p v-if=\"isEntryEnd\">募集終了</p> ")
            ]),
            _createElementVNode("p", _hoisted_9, _toDisplayString(detail.value.title), 1 /* TEXT */),
            (!detail.value.is_offer)
              ? (_openBlock(), _createElementBlock("p", _hoisted_10, " ￥" + _toDisplayString(detail.value.outsourcing_amount.toLocaleString()), 1 /* TEXT */))
              : (_openBlock(), _createElementBlock("p", _hoisted_11, "応相談")),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("img", {
                src: setMediaIcon(detail.value.media_type)
              }, null, 8 /* PROPS */, _hoisted_13),
              _createElementVNode("span", null, _toDisplayString(setMediaName(detail.value.media_type)), 1 /* TEXT */),
              _cache[12] || (_cache[12] = _createElementVNode("img", { src: _imports_4 }, null, -1 /* HOISTED */)),
              _createElementVNode("span", null, _toDisplayString(detail.value.min_follower_count.toLocaleString()) + "登録者以上", 1 /* TEXT */)
            ]),
            _createElementVNode("div", _hoisted_14, [
              _cache[13] || (_cache[13] = _createElementVNode("img", { src: _imports_5 }, null, -1 /* HOISTED */)),
              _createElementVNode("span", null, _toDisplayString(detail.value.recruitment_numbers) + "名様", 1 /* TEXT */)
            ]),
            _createElementVNode("div", _hoisted_15, " 募集期間： " + _toDisplayString(setDiaplayDate(detail.value.entry_started_at, false)) + " 〜 " + _toDisplayString(setDiaplayDate(detail.value.entry_ended_at, true)), 1 /* TEXT */)
          ]),
          _cache[26] || (_cache[26] = _createElementVNode("div", { class: "project-detail-divider" }, null, -1 /* HOISTED */)),
          _withDirectives(_createElementVNode("div", _hoisted_16, _cache[14] || (_cache[14] = [
            _createElementVNode("p", null, "商品概要", -1 /* HOISTED */)
          ]), 512 /* NEED_PATCH */), [
            [_vShow, detail.value.products.length]
          ]),
          _createCommentVNode(" 商品が複数になる場合あり "),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(detail.value.products, (product, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "project-detail-content2",
              key: index
            }, [
              _createElementVNode("p", _hoisted_17, _toDisplayString(product.brand_name), 1 /* TEXT */),
              _createElementVNode("p", _hoisted_18, _toDisplayString(product.name), 1 /* TEXT */),
              _createElementVNode("p", {
                class: _normalizeClass([[
          detail.value.aplication_state != _unref(APPLICATION_STATE).CANNOT_APPLY &&
          detail.value.aplication_state >= _unref(APPLICATION_STATE).APPLIED
            ? 'applied'
            : '',
        ], "p__style__4 pt-17"])
              }, _toDisplayString(product.description), 3 /* TEXT, CLASS */),
              _withDirectives(_createVNode(CommonButton, {
                data: {
          status: 1,
          button: `商品詳細`,
        },
                onClick: ($event: any) => (linkTo(product.url)),
                style: {"margin-top":"30px"}
              }, null, 8 /* PROPS */, ["onClick"]), [
                [_vShow, product.url]
              ])
            ]))
          }), 128 /* KEYED_FRAGMENT */)),
          _cache[27] || (_cache[27] = _createElementVNode("div", { class: "project-detail-divider" }, null, -1 /* HOISTED */)),
          _cache[28] || (_cache[28] = _createElementVNode("div", { class: "project-detail-sub-header" }, [
            _createElementVNode("p", null, "案件概要")
          ], -1 /* HOISTED */)),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("ul", null, [
              _cache[16] || (_cache[16] = _createElementVNode("li", {
                type: "none",
                class: "pt-30"
              }, [
                _createElementVNode("span", null, "訴求内容")
              ], -1 /* HOISTED */)),
              _createElementVNode("p", _hoisted_20, _toDisplayString(detail.value.description), 1 /* TEXT */),
              _createElementVNode("div", _hoisted_21, [
                _cache[15] || (_cache[15] = _createElementVNode("li", { type: "none" }, [
                  _createElementVNode("span", null, "NG事項")
                ], -1 /* HOISTED */)),
                _createElementVNode("ul", _hoisted_22, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(detail.value.prohibitions, (item, index) => {
                    return (_openBlock(), _createElementBlock("li", {
                      type: "disc",
                      key: index
                    }, _toDisplayString(item), 1 /* TEXT */))
                  }), 128 /* KEYED_FRAGMENT */))
                ])
              ]),
              _cache[17] || (_cache[17] = _createElementVNode("li", { type: "none" }, "注意事項", -1 /* HOISTED */)),
              _createElementVNode("p", _hoisted_23, _toDisplayString(detail.value.note), 1 /* TEXT */),
              _withDirectives(_createVNode(CommonButton, {
                data: {
            status: 1,
            button: `詳細資料`,
          },
                onClick: _cache[2] || (_cache[2] = ($event: any) => (linkTo(detail.value.orientation_url))),
                style: {"margin-bottom":"20px"}
              }, null, 512 /* NEED_PATCH */), [
                [_vShow, detail.value.orientation_url]
              ]),
              (detail.value.hashtag)
                ? (_openBlock(), _createElementBlock("li", _hoisted_24, "ハッシュタグ"))
                : _createCommentVNode("v-if", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(splitHashTag(detail.value.hashtag), (hashTag, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "project-detail-content3-hash-tags p__style__3",
                  key: index
                }, " #" + _toDisplayString(hashTag), 1 /* TEXT */))
              }), 128 /* KEYED_FRAGMENT */)),
              (
            detail.value.aplication_state != _unref(APPLICATION_STATE).CANNOT_APPLY &&
            detail.value.aplication_state >= _unref(APPLICATION_STATE).WON && detail.value.hashtag
          )
                ? (_openBlock(), _createBlock(CommonButton, {
                    key: 1,
                    data: {
            status: 3,
            button: `ハッシュタグをコピーする`,
          },
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (copyHashTag())),
                    style: {"margin-top":"20px"}
                  }))
                : _createCommentVNode("v-if", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_25, [
            _cache[18] || (_cache[18] = _createElementVNode("p", { class: "project-detail-content4-title" }, "依頼主", -1 /* HOISTED */)),
            _createElementVNode("p", _hoisted_26, _toDisplayString(detail.value.client.name), 1 /* TEXT */),
            _cache[19] || (_cache[19] = _createElementVNode("p", { class: "project-detail-content4-title" }, "募集期間", -1 /* HOISTED */)),
            _createElementVNode("p", _hoisted_27, _toDisplayString(setDiaplayDate(detail.value.entry_started_at,false)) + " 〜 " + _toDisplayString(setDiaplayDate(detail.value.entry_ended_at,true)), 1 /* TEXT */),
            _cache[20] || (_cache[20] = _createElementVNode("p", { class: "project-detail-content4-title" }, "投稿期間", -1 /* HOISTED */)),
            _createElementVNode("p", _hoisted_28, _toDisplayString(setDiaplayDate(detail.value.post_started_at,false)) + " 〜 " + _toDisplayString(setDiaplayDate(detail.value.post_ended_at,false)), 1 /* TEXT */),
            _createCommentVNode(" <p class=\"project-detail-content4-title\">投稿確認期限</p>\n      <p class=\"p__style__4\">{{ detail.confirm_deadline }}</p> "),
            _cache[21] || (_cache[21] = _createElementVNode("p", { class: "project-detail-content4-title" }, "募集メディア", -1 /* HOISTED */)),
            _createElementVNode("p", _hoisted_29, _toDisplayString(setMediaName(detail.value.media_type)), 1 /* TEXT */),
            _cache[22] || (_cache[22] = _createElementVNode("p", { class: "project-detail-content4-title" }, "エントリー条件", -1 /* HOISTED */)),
            _createElementVNode("p", _hoisted_30, _toDisplayString(detail.value.min_follower_count.toLocaleString()) + "登録者以上 ", 1 /* TEXT */),
            _cache[23] || (_cache[23] = _createElementVNode("p", { class: "project-detail-content4-title" }, "募集人数", -1 /* HOISTED */)),
            _createElementVNode("p", _hoisted_31, _toDisplayString(detail.value.recruitment_numbers.toLocaleString()) + "名 ", 1 /* TEXT */),
            _cache[24] || (_cache[24] = _createElementVNode("p", { class: "project-detail-content4-title" }, "お支払い金額", -1 /* HOISTED */)),
            (!detail.value.is_offer)
              ? (_openBlock(), _createElementBlock("p", _hoisted_32, " ¥" + _toDisplayString(detail.value.outsourcing_amount.toLocaleString()) + " (税別) ", 1 /* TEXT */))
              : (_openBlock(), _createElementBlock("p", _hoisted_33, " 応相談 ")),
            _createCommentVNode(" <p class=\"project-detail-content4-title\">お支払い期日</p>\n      <p class=\"p__style__4\">{{ detail.payment_due_date }}</p> "),
            _cache[25] || (_cache[25] = _createElementVNode("br", null, null, -1 /* HOISTED */))
          ]),
          _createElementVNode("div", _hoisted_34, [
            (!isEntryEnd.value)
              ? (_openBlock(), _createBlock(CommonButton, {
                  key: 0,
                  data: {
          status: 3,
          button: `お問い合わせ`,
        },
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (openContactDialog()))
                }))
              : _createCommentVNode("v-if", true)
          ]),
          _createElementVNode("div", _hoisted_35, [
            _createVNode(CommonButton, {
              data: setButton(),
              onClick: _cache[5] || (_cache[5] = ($event: any) => (confirm()))
            }, null, 8 /* PROPS */, ["data"])
          ]),
          _createVNode(ComfirmDialog, {
            ref_key: "dialog",
            ref: dialog,
            modelValue: showDialog.value,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((showDialog).value = $event)),
            message: message.value,
            button: button.value,
            onApply: _cache[7] || (_cache[7] = ($event: any) => (applyProject()))
          }, null, 8 /* PROPS */, ["modelValue", "message", "button"])
        ]))
      : _createCommentVNode("v-if", true),
    _createCommentVNode(" お問い合わせボタンは募集期間中のみ表示する "),
    _createVNode(ContactDialog, {
      ref_key: "contactDialog",
      ref: contactDialog,
      modelValue: showContactDialog.value,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((showContactDialog).value = $event)),
      projectId: detail.value.id
    }, null, 8 /* PROPS */, ["modelValue", "projectId"])
  ], 64 /* STABLE_FRAGMENT */))
}
}

})